import { cabinetPath, cabinetUrl, currentCabinetRole } from './domains';

export const MERCHANT_IMPERSONATION_TOKEN_KEY = 'merchant_impersonation_access_token';
export const MERCHANT_IMPERSONATION_USER_KEY = 'merchant_impersonation_user';
let endingImpersonation = false;

export const isMerchantImpersonationEntry = () => currentCabinetRole() === 'merchant'
    && window.location.pathname === cabinetPath('merchant', '/impersonate');

export const isMerchantImpersonationActive = () => endingImpersonation
    || Boolean(sessionStorage.getItem(MERCHANT_IMPERSONATION_TOKEN_KEY));

export const getMerchantAccessToken = () => isMerchantImpersonationActive()
    ? sessionStorage.getItem(MERCHANT_IMPERSONATION_TOKEN_KEY)
    : localStorage.getItem('merchant_access_token');

export const getStoredMerchantUser = () => JSON.parse(
    (isMerchantImpersonationActive()
        ? sessionStorage.getItem(MERCHANT_IMPERSONATION_USER_KEY)
        : localStorage.getItem('merchant_user')) || 'null'
);

export const storeMerchantUser = (user: unknown) => {
    if (isMerchantImpersonationActive()) {
        if (!endingImpersonation) sessionStorage.setItem(MERCHANT_IMPERSONATION_USER_KEY, JSON.stringify(user));
    } else {
        localStorage.setItem('merchant_user', JSON.stringify(user));
    }
};

export const beginMerchantImpersonation = (token: string) => {
    endingImpersonation = false;
    sessionStorage.removeItem(MERCHANT_IMPERSONATION_USER_KEY);
    sessionStorage.setItem(MERCHANT_IMPERSONATION_TOKEN_KEY, token);
};

export const clearMerchantImpersonation = () => {
    sessionStorage.removeItem(MERCHANT_IMPERSONATION_TOKEN_KEY);
    sessionStorage.removeItem(MERCHANT_IMPERSONATION_USER_KEY);
};

export const finishMerchantImpersonation = () => {
    // Keep concurrent failed requests from falling back to the ordinary session.
    if (endingImpersonation) return;
    endingImpersonation = true;
    clearMerchantImpersonation();
    window.location.replace(cabinetUrl('admin', '/dashboard'));
};

export const clearMerchantSession = () => {
    if (isMerchantImpersonationActive()) {
        finishMerchantImpersonation();
        return;
    }
    localStorage.removeItem('merchant_access_token');
    localStorage.removeItem('merchant_user');
};

export const merchantImpersonationExpiresAt = () => {
    try {
        const payload = getMerchantAccessToken()?.split('.')[1];
        if (!payload) return 0;
        const { exp } = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return typeof exp === 'number' && Number.isFinite(exp) ? exp * 1000 : 0;
    } catch {
        return 0;
    }
};
